import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useAuth } from "@/auth/AuthContext";

/** Bootstraps the browser with the runtime config (Maps key, app version).
 *  Cached for the duration of the page; stale on tab focus to pick up new
 *  versions deployed mid-session.
 *
 *  Gated on an authenticated session: `/api/meta/config` ships the Maps
 *  API key and is therefore auth-protected, so firing it pre-login (the
 *  global VersionBanner mounts on the login page too) just produced a
 *  401 in the console on every visit to the sign-in screen. Everything
 *  that needs config — the form's Google Places autocomplete, the
 *  mid-session "update available" banner — only matters once signed in,
 *  so deferring the fetch until then is both correct and quieter. */
export function useConfig() {
  const { state } = useAuth();
  return useQuery({
    queryKey: ["meta", "config"],
    queryFn: ({ signal }) => api.meta.config(signal),
    enabled: state.status === "authenticated",
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
}
